'use strict';

import { matchesBreakpoint, queryFirst, queryAll } from './domUtil';
import { sauce } from 'fitpredictor/product/secretsauce';
import detail from './product/detail';
import pdpQuickView from './product/pdpQuickView';
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/shippingPreference'));
    processInclude(detail);
    processInclude(require('./components/pdpSwiperSlider'));
    processInclude(require('./components/pickUpInStore'));
    processInclude(require('instore/product/pdpInstoreInventory'));
    if (!!queryFirst('#fitPredictorEnabled')) {
        sauce($('.product-detail.product-wrapper'));
    }
    processInclude(require('./product/monogram'));
    processInclude(require('./product/shoppableMedia'));
    processInclude(require('./product/flexibleComponents'));
    const pdpContainer = queryFirst('.pdp-container');
    if (pdpContainer) {
        const selectedSize = queryFirst('.size-btn.selected');
        if (selectedSize) {
            selectedSize.click();
        }
    }
    processInclude(pdpQuickView);
    const isStyliticsPDPAPIWidgetEnabled = !!queryFirst('#isStyliticsPDPAPIWidgetEnabled');
    if (isStyliticsPDPAPIWidgetEnabled) {
        // dynamically load the Stylitics script only when the Stylitics PDP widget is enabled
        processInclude(require('./stylitics/styliticsCustomWidget'));
    }

    // Afterpay
    require('afterpay/afterpay')({
        anchors: '.pdp-product-promo',
        renderMode: 'adjacent',
        observerTargets: '.prices',
        priceTargets: ['.sales .price-value', '.list .price-value', '.sales .value'],
        showExcluded: false,
        observerIgnoreAnchor: true
    });
});

